import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FreudSelectModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { AppointmentsNoShowSelectComponent } from './appointments-no-show-select.component';

@NgModule({
	declarations: [AppointmentsNoShowSelectComponent],
	imports: [CommonModule, FreudSelectModule, TranslateModule, FormsModule],
	exports: [AppointmentsNoShowSelectComponent],
})
export class AppointmentsNoShowSelectModule {}
